import auth from "./auth";
import _ from "lodash";
function can(permission){
    let permissions = auth.getUserPermission();
    let roles = auth.getUserRole();
    // console.log("can permissions", permissions);
    // console.log("can permission", permission);

    // if(permissions.includes(permission)){
    //     console.log("Can true");return true;
    // } 

    // if (_.has(permissions, permission)) {
        
    //   }

    // if(roles.some(p => _.has(p, 'name') && p.name === permission)){
  
    //     return true;
    // }

    if(permission === 'superadmin' && roles.name === 'superadmin'){
        // console.log("superadmin found");
        return true;
    }

    
    if(permissions.some(p => _.has(p, 'name') && p.name === permission)){
  
        return true;
    }
    
    if(permission ==='all') return true;


    return false;
}

export default can;


